import React from 'react';
import { TopProgressBar } from 'react-admin-base-bootstrap';
import { Container } from 'reactstrap';
import GlobalMenuStateProvider from '../Providers/GlobalMenuStateProvider.js';
import Themes from '../Themes.js';
export function MainLayout(props) {
    const { children } = props;
    return React.createElement(GlobalMenuStateProvider, null,
        React.createElement(Themes, null,
            React.createElement(TopProgressBar, null),
            children[0],
            children[1],
            React.createElement("div", { className: "main-content" },
                React.createElement("div", { className: "page-content" },
                    React.createElement(Container, { fluid: true }, children[2])),
                children[3])));
}
